<template>
  <a-layout class="dashboard">
    <a-layout-sider v-if="!isMobile()" theme="light">
      <a-menu v-model:selectedKeys="selectedKeys" mode="inline" style="height: 100%;">
        <div class="logo">
          <div style="width: 32px; float: left;">
            <img src="/assets/images/logo.svg"/>
          </div>
          <span style="font-size: 32px; line-height: 32px; padding-left: 12px;">
            Vertex
          </span>
        </div>
        <a-menu-item v-for="item of menu" :key="item.path" @click="$goto(item.path, $router)">
          <fa :icon="item.icon" style="width: 32px;"></fa>
          <span>{{item.title}}</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-drawer v-if="isMobile()" v-model:visible="visible" :closable="false" placement="left" width="220">
      <a-menu v-model:selectedKeys="selectedKeys" mode="inline" style="width: 172px; font-size: 14px; height: 100%;">
        <div class="logo">
          <div style="width: 32px; float: left;">
            <img src="/assets/images/logo.svg"/>
          </div>
          <span style="font-size: 32px; line-height: 32px; padding-left: 12px;">
            Vertex
          </span>
        </div>
        <a-menu-item v-for="item of menu" :key="item.path" @click="$goto(item.path, $router)">
          <fa :icon="item.icon" style="width: 32px;"></fa>
          <span>{{item.title}}</span>
        </a-menu-item>
      </a-menu>
      <div class="user-badge">
        <div style="width: 32px; float: left;">
          <img src="/assets/images/logo.svg"/>
        </div>
        <div style="font-size: 14px; line-height: 32px; float: left; width: 116px;">
          <div style="margin: 0 auto; width: fit-content;">{{user.nickname}}</div>
        </div>
      </div>
    </a-drawer>
    <a-layout>
      <a-layout-header v-if="isMobile()" style="padding: 0; background: #fff;">
        <fa v-if="!visible" :icon="['fas', 'bars']" @click="visible = !visible" style="font-size: 16px; padding-left: 16px;"/>
        <div style="margin: 0 auto; width: calc(100% - 32px); position: absolute; display: inline-block">
          <div style="margin: 0 auto; width: 144px;">
            <div style="width: 24px; float: left;">
              <img src="/assets/images/logo.svg"/>
            </div>
            <span style="font-size: 22px; padding-left: 6px;">
              Vertex
            </span>
          </div>
        </div>
      </a-layout-header>
      <a-layout-content
        :style="{ margin: '16px', 'overflow-y': 'auto', height: 'calc(var(--vh, 1vh) * 100 - 64px)' }">
        <router-view></router-view>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
export default {
  data () {
    return {
      selectedKeys: [],
      visible: false,
      menu: [],
      user: {
        menu: []
      }
    };
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted () {
    this.selectedKeys = [this.$route.path];
    try {
      const res = await this.$api().user.get();
      this.$message().success(`欢迎回来, ${res.data.nickname}`);
      this.menu = res.data.menu;
      this.user = res.data;
    } catch (e) {
      this.$message().error(e.message);
    }
  }
};
</script>
<style scoped>
.logo {
  height: 32px;
  margin: 24px auto;
  width: 148px;
}

.user-badge {
  width: 148px;
  position: absolute;
  margin: 0 11.5px;
  bottom: 48px;
}

.ant-layout {
  background: #fff;
}

.dashboard {
  height: calc(var(--vh, 1vh) * 100);
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: initial;
}
</style>
